import React, { useState, useEffect } from 'react';
import ButtonBase from '../../Buttons/ButtonBase';
import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { firestore } from '../../../configs/environments/firebase/firebaseApp';
import './CardPremiumMainHolder.scss'

const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles({
  linkStyle: {},
  buttonStyle: {}
});

const CardPremiumMainHolder = props => {
  let { authClient, preview } = props;
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width: 619.98px)')
  const [ data, setData ] = useState({})

  useEffect(() => {
    if (!preview) {
      firestore
        .collection("lawyerUsers").doc(authClient.idLawFirm)
        .get()
        .then(doc => {
          setData(doc.data())
        })
        .catch(error=>{
          console.log('error', error);
        })
    } else {
      if (authClient.lawFirmData) {
        setData(authClient.lawFirmData)
      }
    }
  }, [authClient.idLawFirm, authClient.lawFirmData, preview])

  function uniq(a) {
    let prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];
    return a.filter(function(item) {
      let type = typeof item;
      if(type in prims)
        return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
      else
        return objs.indexOf(item) >= 0 ? false : objs.push(item);
    });
  }

  const formatArray = (oldArray) => {
    let outStr = "";
    const arr = uniq(oldArray)
    if (arr.length === 1) {
      outStr = arr[0];
    } else if (arr.length === 2) {
      outStr = arr.join(' y ');
    } else if (arr.length > 2) {
      outStr = arr.slice(0, -1).join(', ') + ' y ' + arr.slice(-1);
    }
    return outStr;
  }

  return (
    <div className='cardPremiumMainHolder'>
      <p className='cardPremiumMainHolder_title'>Titular del despacho</p>
      <div className='cardPremiumMainHolder_container'>
        <div className='cardPremiumMainHolder_textContainer'>
          <p className='cardPremiumMainHolder_textContainer-officeName'>
            {data.officeName ? data.officeName : ''}
          </p>
          {isMobile ?
            <div className='cardPremiumMainHolder_imageContainer'>
              <img
                className='cardPremiumMainHolder_imageContainer-avatarMobile'
                src={
                  data &&
                  data.imgProfile ?
                  data.imgProfile :
                  lawFirmAvatar
                }
                alt='avatar'
              />
            </div> : null
          }
          <p
            className={isMobile ?
              'cardPremiumMainHolder_textContainer-paragraphMobile' :
              'cardPremiumMainHolder_textContainer-paragraph'
            }
          >
            {data ?
              `En ${data.officeName ? data.officeName : ''} contamos con amplia experiencia
              en distintas ramas del Derecho${data.specialties && data.specialties.length !== 0 ? ` como son: ${formatArray(data.specialties)}.` : '.'}
              ${data.states && data.states.length !== 0 ?
                `Sabemos de la prontitud con la que las personas necesitan asesoría jurídica,
                por eso ponemos a su disposición nuestros servicios en ${formatArray(data.states)}.`
                : ''
              }`
              : ''
            }
          </p>
        </div>
        {!isMobile ?
          <div className='cardPremiumMainHolder_imageContainer'>
            <img
              className='cardPremiumMainHolder_imageContainer-avatar'
              src={
                data &&
                data.imgProfile ?
                data.imgProfile :
                lawFirmAvatar
              }
              alt='avatar'
            />
          </div> : null
        }
      </div>
      {!preview ?
        <ButtonBase
          direction={`/despacho/${authClient.idLawFirm}`}
          linkStyle={classes.linkStyle}
          buttonStyle={classes.buttonStyle}
          variant='primarySolidOutlined'
        >
          Visitar despacho
        </ButtonBase> : null
      }
    </div>
  );
};

export default CardPremiumMainHolder;
